import React, { useEffect, useState } from 'react';
import classes from "./styles/videoSection.module.css";

const VideoSection = () => {
  const [randomUrl, setRandomUrl] = useState("");

  useEffect(() => {
    const urls = [
      "https://www.instagram.com/reel/DFIbl2SvarC/embed",
      "https://www.instagram.com/reel/DFDktCksklQ/embed",
      "https://www.instagram.com/reel/DE5Gq4uvhFT/embed",
      "https://www.instagram.com/reel/DEsND8evqtO/embed",
      "https://www.instagram.com/reel/DEnLESSM_QQ/embed",
      "https://www.instagram.com/reel/DEkI-SWP9YV/embed"
    ]
    
    const selectedUrl = urls[Math.floor(Math.random() * urls.length)];
    setRandomUrl(selectedUrl);
  }, []);

  return (
    <div className={classes.container}>
      <div className={classes.videoCon}>
      {randomUrl && (
        <iframe 
          className={classes.video}
          src={"https://www.instagram.com/reel/DFlV_dZzuHc/embed"} 
          title="Instagram Reel" 
          width="400" 
          height="550" 
          frameBorder="0" 
          scrolling="no" 
          allowTransparency="true">
        </iframe>
      )}
      </div>

      <div className={classes.videoCon}>
      {randomUrl && (
        <iframe 
          className={classes.video}
          src={randomUrl} 
          title="Instagram Reel" 
          width="400" 
          height="550" 
          frameBorder="0" 
          scrolling="no" 
          allowTransparency="true">
        </iframe>
      )}
      </div>

      <div className={classes.videoCon}>
      {randomUrl && (
        <iframe 
          className={classes.video}
          src={"https://www.instagram.com/reel/DFdQlx-S2ZL/embed"} 
          title="Instagram Reel" 
          width="400" 
          height="550" 
          frameBorder="0" 
          scrolling="no" 
          allowTransparency="true">
        </iframe>
      )}
      </div>

    </div>
  )
}

export default VideoSection;
